import { STATUS } from "api/reactQuery/queries/tasks.types"

export interface IResetBalanceTaskOutcome {
  clearTask: boolean
  invalidateStudents: boolean
  toast: { titleKey: string; variant: "success" | "error" | "info" } | null
}

export const isResetBalanceTaskInFlight = (
  status: STATUS | undefined
): boolean => status === "PENDING" || status === "IN_PROGRESS"

export const getResetBalanceTaskOutcome = (
  status: STATUS | undefined
): IResetBalanceTaskOutcome => {
  if (isResetBalanceTaskInFlight(status)) {
    return { clearTask: false, invalidateStudents: false, toast: null }
  }

  switch (status) {
    case "SUCCESS":
      return {
        clearTask: true,
        invalidateStudents: true,
        toast: {
          titleKey: "students.studentsBalancesHasBeenSuccessfullyReset",
          variant: "success",
        },
      }
    case "FAILURE":
      return {
        clearTask: true,
        invalidateStudents: false,
        toast: {
          titleKey: "students.resetBalanceFailed",
          variant: "error",
        },
      }
    default:
      return { clearTask: false, invalidateStudents: false, toast: null }
  }
}

// A task whose task_id is confirmed-gone (backend 404) or whose persisted
// entry has exceeded the staleness TTL. Neither case corresponds to a real
// STATUS value, so it can't flow through getResetBalanceTaskOutcome above -
// see PRD "Amendment: localStorage persistence + staleness guard".
export const getResetBalanceStaleOutcome = (): IResetBalanceTaskOutcome => ({
  clearTask: true,
  invalidateStudents: false,
  toast: {
    titleKey: "students.resetBalanceStatusUnknown",
    variant: "info",
  },
})
